import React from "react";
import { FaFacebook, FaWhatsapp, FaEnvelope } from "react-icons/fa";

function Contact() {
  return (
    <section style={styles.container}>
      <h1>Contact Us</h1>

      <div style={styles.links}>
        <a href="https://www.facebook.com/share/1Bx9naCidG/" target="_blank" rel="noreferrer">
          <FaFacebook size={30} style={{ marginRight: "8px" }} /> Facebook
        </a>

        <a href="https://wa.me/2348103336533" target="_blank" rel="noreferrer">
          <FaWhatsapp size={30} style={{ marginRight: "8px" }} /> WhatsApp
        </a>

        <a href="mailto:advocacyunblemished@gmail.com">
          <FaEnvelope size={30} style={{ marginRight: "8px" }} /> Email
        </a>
      </div>
    </section>
  );
}

const styles = {
  container: {
    textAlign: "center",
    padding: "80px 20px"
  },
  links: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    fontSize: "18px",
    alignItems: "center"
  }
};

export default Contact;